import { Link } from "react-router-dom";
import { InstagramLogo, FacebookLogo, EnvelopeSimple, Phone, MapPin, Clock } from "@phosphor-icons/react";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer data-testid="footer" className="bg-matte text-smoke py-16 md:py-24">
      <div className="container mx-auto px-4 md:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 md:gap-8">
          {/* Brand Column */}
          <div className="lg:col-span-1">
            <Link to="/" className="font-serif text-2xl tracking-tight text-smoke">
              <span className="font-light">Medical</span>{" "}
              <span className="font-medium">Aesthetic Arts</span>
            </Link>
            <p className="mt-4 text-xs text-taupe">aestheticmedicalarts.online</p>
            <p className="mt-4 text-sm font-light text-smoke/60 leading-relaxed">
              Where artistry meets science. Crafting natural, balanced beauty through 
              customized facial design plans.
            </p>
            {/* Social Links */}
            <div className="flex gap-4 mt-8">
              <a
                href="https://instagram.com"
                target="_blank"
                rel="noopener noreferrer"
                data-testid="social-instagram"
                className="rounded-full border border-smoke/20 p-3 hover:bg-smoke hover:text-matte hover:border-smoke transition-all duration-300"
              >
                <InstagramLogo size={18} weight="light" />
              </a>
              <a
                href="https://facebook.com"
                target="_blank"
                rel="noopener noreferrer"
                data-testid="social-facebook"
                className="rounded-full border border-smoke/20 p-3 hover:bg-smoke hover:text-matte hover:border-smoke transition-all duration-300"
              >
                <FacebookLogo size={18} weight="light" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-xs uppercase tracking-[0.2em] mb-6 text-taupe">
              Quick Links
            </h4>
            <nav className="flex flex-col gap-4">
              {["About", "Services", "Gallery", "Skincare", "VIP Membership", "Contact"].map(
                (item) => (
                  <Link
                    key={item}
                    to={`/${item.toLowerCase().replace(" ", "-")}`}
                    className="text-sm font-light text-smoke/60 hover:text-smoke transition-colors duration-200"
                  >
                    {item}
                  </Link>
                )
              )}
            </nav>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-xs uppercase tracking-[0.2em] mb-6 text-taupe">
              Contact
            </h4>
            <div className="flex flex-col gap-4">
              <a
                href="tel:+18449436191"
                className="flex items-center gap-3 text-sm font-light text-smoke/60 hover:text-smoke transition-colors duration-200"
              >
                <Phone size={16} weight="light" />
                (844) 943-6191
              </a>
              <a
                href="mailto:info@aestheticmedicalarts.online"
                className="flex items-center gap-3 text-sm font-light text-smoke/60 hover:text-smoke transition-colors duration-200"
              >
                <EnvelopeSimple size={16} weight="light" />
                info@aestheticmedicalarts.online
              </a>
              <div className="flex items-start gap-3 text-sm font-light text-smoke/60">
                <Clock size={16} weight="light" className="mt-1 flex-shrink-0" />
                <span>
                  Mon-Fri: 9am - 5pm
                  <br />
                  Sat-Sun: 11am - 4pm
                </span>
              </div>
            </div>
          </div>

          {/* Locations */}
          <div>
            <h4 className="text-xs uppercase tracking-[0.2em] mb-6 text-taupe">
              Locations
            </h4>
            <div className="flex flex-col gap-6">
              <div className="flex items-start gap-3 text-sm font-light text-smoke/60">
                <MapPin size={16} weight="light" className="mt-1 flex-shrink-0" />
                <div>
                  <p className="text-taupe text-xs uppercase tracking-wider mb-1">Main Office</p>
                  <span>
                    3100 Smoketree Ct, Ste 800
                    <br />
                    Raleigh, NC 27604
                  </span>
                </div>
              </div>
              <div className="flex items-start gap-3 text-sm font-light text-smoke/60">
                <MapPin size={16} weight="light" className="mt-1 flex-shrink-0" />
                <div>
                  <p className="text-taupe text-xs uppercase tracking-wider mb-1">Headquarters</p>
                  <span>
                    1950 Bluegrass Cir, Ste 360
                    <br />
                    Cheyenne, WY 82001
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-16 pt-8 border-t border-smoke/10 flex flex-col md:flex-row justify-between items-center gap-4">
          <div className="flex flex-col md:flex-row items-center gap-2 md:gap-6">
            <p className="text-xs font-light text-smoke/40">
              © {currentYear} Medical Aesthetic Arts LLC. All rights reserved.
            </p>
            <a
              href="https://npiregistry.cms.hhs.gov/provider-view/1518879022"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="npi-link"
              className="text-xs font-light text-taupe hover:text-smoke transition-colors"
            >
              NPI: 1518879022
            </a>
          </div>
          <div className="flex gap-8">
            <Link
              to="/privacy"
              className="text-xs font-light text-smoke/40 hover:text-smoke/60 transition-colors"
            >
              Privacy Policy
            </Link>
            <Link
              to="/terms"
              className="text-xs font-light text-smoke/40 hover:text-smoke/60 transition-colors"
            >
              Terms of Service
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
